<template>
  <!-- 调控记录 -->
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('groupmanage.gname')">
        <el-input :placeholder="$t('groupmanage.placeholder')" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <!-- <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button> -->
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
      <el-table-column label="名称" prop="name" align="center"></el-table-column>
      <el-table-column label="调控数" prop="strate_num" width="80" align="center"></el-table-column>
      <el-table-column label="记录数" prop="info_num" width="80" align="center"></el-table-column>
      <el-table-column label="异常数" prop="error_num" width="80" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="180" align="center"></el-table-column>
      <el-table-column label="结束时间" prop="end_time" width="180" align="center"></el-table-column>

      <el-table-column :label="$t('publics.operation')" width="120" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="detailVisible" title="调控记录详情" width="1800px" :close-on-click-modal="false">
      <el-row type="flex" justify="center">
        <el-col :span="22">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm">
            <el-row :gutter="20">
              <el-form-item label="名称" prop="name">
                <el-input v-model="detailForm.name" readonly disabled />
              </el-form-item>
              <el-form-item label="调控数" prop="create_time">
                {{ detailForm.strate_num }} <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;记录数&nbsp;&nbsp;&nbsp;{{ detailForm.info_num }}</label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;异常数&nbsp;&nbsp;&nbsp;{{ detailForm.error_num }}</label>
              </el-form-item>
              <el-form-item label="信息提示" prop="strate_content">
                <div class="strate-content">
                  <div class="strate-info itemst" v-for="(item, index) in detailForm.strate_obj?.infos">{{ ++index }}、
                    <div style="display: inline;" v-html="item"></div></div>
                </div>
                </el-form-item>
              <el-form-item label="异常信息" prop="strate_content">
                <div class="strate-content">
                  <div class="strate-error itemst" v-for="(item, index) in detailForm.strate_obj?.errors">{{ ++index }}、{{ item }}</div>
                </div>
              </el-form-item>
                <el-form-item label="调控过程" prop="strate_content">
                <div class="strate-content">
                  <div class="strate-info itemst" v-for="(item, index) in detailForm.strate_obj?.strates">{{ ++index }}、{{ item }}</div>
                </div>
              </el-form-item>
              <el-form-item label="开始时间" prop="create_time">
                {{ detailForm.create_time }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <label>结束时间&nbsp;&nbsp;&nbsp;{{ detailForm.end_time }}</label>
              </el-form-item>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { GetCtrStrateLogPageList } from "@/api/dev_data_view"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    return {
      detailForm: {},
      detailVisible: false,
      visible: {
        editGroup: false
      },
      tableData: [],
      filter: {
        groupName: ""
      },
      loading: false,
      isUpdate: true,
      gid: "" //街道id
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
  },
  methods: {
    onDetail(row) {
      this.detailForm = row // { ...row }
      this.detailForm.strate_obj = JSON.parse(row.strate_content)
      console.log(this.detailForm.strate_obj)
      this.detailVisible = true
    },
    getData() {
      this.loading = true
      GetCtrStrateLogPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
.strate-content {
  line-height: 20px;
}
.strate-content .lhead {
  line-height: 20px;
}
</style>
